import { useState, useEffect } from 'react';

import { travel, axiosConfig } from '../../api';

export interface IThereIsTravelsData {
  isTravels: boolean;
  isLoading: boolean;
  isError: boolean;
}

interface IThereIsTravelsResponse {
  data: IThereIsTravelsData;
}

export const useThereIsTravels = (companyId?: string) => {
  const [isTravels, setIsTravels] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchIsTravels = () => {
      travel
        .get<IThereIsTravelsResponse>('Travels/GetTravelsByCompany', axiosConfig)
        .then((result) => {
          const { data } = result.data;
          setIsTravels(data.isTravels);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsError(true);
          throw new Error(error);
        });
    };

    if (!companyId) {
      setIsError(true);
      throw new Error('Not receveid companyId');
    }

    fetchIsTravels();
  }, [companyId]);

  return { isTravels, isLoading, isError };
};
